import { render, staticRenderFns } from "./QuestionReviewView.vue?vue&type=template&id=5b8747a5&"
import script from "./QuestionReviewView.vue?vue&type=script&lang=js&"
export * from "./QuestionReviewView.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReviewView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports